const shuttles = {
  shuttles: 'Shuttlebusse',

  toast: {
    error: {
      badResponse: '[Shuttle] fehlerhafte Serverantwort',
      create: {},
      edit: {},
    },
    success: {
      create: {},
      edit: {
        default: '[Shuttle] erfolgreich aktualisiert',
      },
      delete: {
        default: '[Shuttle] erfolgreich gelöscht',
      },
    },
  },

  create: {
    errorToast: {
      message: 'Es ist ein Fehler aufgetreten. Shuttle konnte nicht erstellt werden',
    },
    successToast: {
      message: 'Erfolg! Shuttle wurde erfolgreich hinzugefügt',
    },
  },

  edit: {
    errorToast: {
      message: 'Es ist ein Fehler aufgetreten. Shuttle konnte nicht aktualisiert werden',
    },
    successToast: {
      message: 'Erfolg! Shuttle wurde erfolgreich aktualisiert',
    },
  },

  createNew: 'Erstellen',
  deleteBtn: 'Löschen',

  deleteModal: {
    header: 'Shuttles löschen',
    body: 'Sie sind dabei, {{num}} Shuttles zu löschen.',
  },
  table: {
    headers: {
      id: 'Ausweis',
      line: 'Linie',
      direction: 'Richtung',
      weekdays: 'Wochentage',
      supplier: 'Anbieter',
      pax: 'Personen',
    },
    notAvailable: 'Nicht verfügbar',
    actions: {
      duplicate: 'Duplikat',
      delete: 'Löschen',
      export: 'Exportieren',
    },
  },

  form: {
    header: {
      createShuttle: {
        title: 'Neues Shuttle',
      },

      updateShuttle: {
        title: 'Shuttle',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Einreichen',
        update: 'Einreichen',
      },
    },

    info: {
      details: {
        header: {
          create: 'Shuttle erstellen',
          edit: 'Shuttle bearbeiten',
          information: 'Shuttle-Informationen',
        },
        shuttleBy: {
          flexibleTime: 'Flexible Arbeitszeit',
          fixedTime: 'Feste Zeit',
        },
        fields: {
          unit: 'Bereich',
          supplier: 'Betrieben von',
          hour1: 'Von',
          hour2: 'Bis',
          shuttleBy: 'Shuttle von',
          code: 'Code',
          name: 'Name',
          area: 'Zone',
          line: 'Linie',
          profile: 'Profil',
          direction: 'Richtung',
          weekDays: 'Wochentage',
          drivers: 'Fahrer',
          pax: 'Personen',
          paymentType: 'Bezahlarten',
          routingType: 'Routing-Typ',
        },
        paymentTypeOptions: {
          free: 'Frei',
          opusCard: 'OPUS-Karte',
          cashOnBoard: 'Bargeld an Bord',
          correspondance: 'Korrespondenz',
        },
        routingTypeOptions: {
          dynamic: 'Dynamisch',
          demand: 'Nachfrage',
          bus: 'Bus',
        },
      },
      times: {
        header: 'Zeit',
        fields: {
          hour: 'Stunde',
          limit: 'Limit',
          busses: 'Busse',
          holidays: 'Feiertage',
        },
        btnAdd: 'Zeit hinzufügen',
      },
      stops: {
        header: 'Haltestellen',
        fields: {
          address: 'Adresse',
          name: 'Name',
          zone: 'Zone',
          save: 'Speichern',
        },
        btnAdd: 'Stopp hinzufügen',
      },
      zone: '(Zone: {{zone}})',
    },
    validation: {
      unitRequired: 'Bereich ist erforderlich',
      codeRequired: 'Code ist erforderlich',
      nameRequired: 'Name ist erforderlich',
      paxRequired: 'Personenzahl ist erforderlich',
      hourRequired: 'Stunde ist erforderlich',
      limitRequired: 'Limit ist erforderlich',
      latRequired: 'Breitengrad ist erforderlich',
      lonRequired: 'Längengrad erforderlich',
    },
    weekDays: {
      sunday: 'Sonntag',
      monday: 'Montag',
      tuesday: 'Dienstag',
      wednesday: 'Mittwoch',
      thursday: 'Donnerstag',
      friday: 'Freitag',
      saturday: 'Samstag',
    },
  },
};

export default shuttles;
